import { AssetType, TypeArray, CropDataType, TrimDataType } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type AssetRef = {
  type: AssetType
  id: string
  snap_id: string
  cropData?: CropDataType | null
  trimData?: TrimDataType | null
  fileName?: string
  width?: number
  height?: number
  altText?: string
}

const reducerAction = {
  type: actionCreatorTypeGuard<AssetRef, AssetType>("type", "AssetRef"),
  id: actionCreatorTypeGuard<AssetRef, string>("id", "AssetRef"),
  snap_id: actionCreatorTypeGuard<AssetRef, string>("snap_id", "AssetRef"),
  fileName: actionCreatorTypeGuard<AssetRef, string>("fileName", "AssetRef"),
  altText: actionCreatorTypeGuard<AssetRef, string>("altText", "AssetRef"),
  cropData: actionCreatorTypeGuard<AssetRef, AssetRef["cropData"]>(
    "cropData",
    "AssetRef"
  ),
  trimData: actionCreatorTypeGuard<AssetRef, AssetRef["trimData"]>(
    "trimData",
    "AssetRef"
  ),
  width: actionCreatorTypeGuard<AssetRef, number>("width", "AssetRef"),
  height: actionCreatorTypeGuard<AssetRef, number>("height", "AssetRef"),
  __record: actionCreatorTypeGuard<TypeArray, AssetRef>("AssetRef", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<AssetRef>>(
    "create",
    "__create/AssetRef"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof AssetRef
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const assetRefAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const assetRefReducer = reducerTypeGuard<AssetRef>()
  .case(...reducerAction.type)
  .case(...reducerAction.id)
  .case(...reducerAction.snap_id)
  .case(...reducerAction.cropData)
  .case(...reducerAction.trimData)
  .case(...reducerAction.fileName)
  .case(...reducerAction.altText)
  .case(...reducerAction.width)
  .case(...reducerAction.height)
  .build()
